import Svg, { G, Path } from 'react-native-svg'
export const BhimUpi = ({ width = '108.981', height = '15', color = '#6d6e71' }: any) => {
  return (
    <Svg id="BHIM_UPI_logo" data-name="BHIM UPI logo" width={width} height={height} viewBox="0 0 108.981 15">
      <G id="layer1" transform="translate(0 0.084)">
        <G id="g790" transform="translate(54.172 0)">
          <Path id="path792" d="M1.525,0,4.483,5.884l-6.22,5.883Z" transform="translate(1.736)" fill="#008c44" />
        </G>
        <G id="g794" transform="translate(52.093 0)">
          <Path id="path796" d="M1.527,0,4.483,5.884l-6.223,5.883Z" transform="translate(1.739)" fill="#f47920" />
        </G>
        <G id="g798" transform="translate(0.7 0.035)">
          <Path
            id="path800"
            d="M5.873,3.975a1.589,1.589,0,0,1-1.234.894H-3.717l.672-2.406H5.392a.843.843,0,0,1,.619.627,1.587,1.587,0,0,1,.015.211c0,.036,0,.073-.005.109,0,.015,0,.03,0,.045Zm-7.6-6.219H6.721a.849.849,0,0,1,.539.41,1.6,1.6,0,0,1,.064.445,1.559,1.559,0,0,1-.021.244l-.022.077L7.2-.775A1.589,1.589,0,0,1,5.929.18H-2.408Zm8.8,9.062a1.559,1.559,0,0,0,.574-.829L8.63,2.463a.869.869,0,0,0-.117-.807A.88.88,0,0,0,7.77,1.33,1.5,1.5,0,0,0,8.7,1,1.541,1.541,0,0,0,9.268.18l.983-3.521a.956.956,0,0,0-.1-.849.858.858,0,0,0-.749-.337H-3.428L-6.689,7.153H6.145a1.5,1.5,0,0,0,.928-.335"
            transform="translate(6.689 4.527)"
            fill={color}
          />
        </G>
        <G id="g802" transform="translate(16.321 0.045)">
          <Path
            id="path804"
            d="M6.9,0,5.612,4.691H-3.646L-2.356,0h-2.3l-3.2,11.641h2.3L-4.272,6.97H4.985L3.7,11.641H6L9.2,0Z"
            transform="translate(7.861)"
            fill={color}
          />
        </G>
        <G id="g806" transform="translate(31.739 0.085)">
          <Path id="path808" d="M1.084,5.441H-1.234L1.989-6.2H4.305Z" transform="translate(1.234 6.197)" fill={color} />
        </G>
        <G id="g810" transform="translate(35.629 0.074)">
          <Path
            id="path812"
            d="M8.305,0-1.31,8.149-4.664,2.575-6.214,0h-.042l-.73,2.645L-9.459,11.6h2.3l1.733-6.28,3.672,6.3L4.329,6.048,2.8,11.6h2.3L7.354,3.46,8.309,0Z"
            transform="translate(9.459)"
            fill={color}
          />
        </G>
        <G id="g814" transform="translate(0 13.124)">
          <Path
            id="path816"
            d="M.247.34H.36A.687.687,0,0,0,.674.285.267.267,0,0,0,.806.1C.828.007.816-.059.772-.1A.5.5,0,0,0,.479-.154H.366ZM.066,1.1h.1A1.749,1.749,0,0,0,.4,1.089a.372.372,0,0,0,.133-.042A.338.338,0,0,0,.7.829.262.262,0,0,0,.7.685.174.174,0,0,0,.62.591.3.3,0,0,0,.53.561.873.873,0,0,0,.388.551H.2Zm-.347.235L.131-.387h.46a1.4,1.4,0,0,1,.286.021A.331.331,0,0,1,1.021-.3a.285.285,0,0,1,.095.154.443.443,0,0,1,0,.21A.5.5,0,0,1,.99.294.489.489,0,0,1,.763.422.281.281,0,0,1,.981.559.383.383,0,0,1,1,.846a.626.626,0,0,1-.086.2A.627.627,0,0,1,.77,1.2a.555.555,0,0,1-.209.1,1.769,1.769,0,0,1-.38.029Z"
            transform="translate(0.282 0.387)"
            fill={color}
          />
        </G>
        <G id="g818" transform="translate(2.241 13.124)">
          <Path
            id="path820"
            d="M0,.805.412-.917h.3L.557-.282h.9l.152-.635h.3L1.49.805h-.3l.2-.837H.5L.3.805Z"
            transform="translate(0 0.917)"
            fill={color}
          />
        </G>
        <G id="g822" transform="translate(4.672 13.056)">
          <Path
            id="path824"
            d="M.371.521H.88L.787.128C.782.1.778.074.774.041S.768-.027.766-.068C.746-.03.728.006.709.038S.671.1.653.128Zm.658.676L.929.754H.206L-.112,1.2H-.423L.889-.593,1.343,1.2Z"
            transform="translate(0.423 0.593)"
            fill={color}
          />
        </G>
        <G id="g826" transform="translate(7.38 13.125)">
          <Path
            id="path828"
            d="M.249.343H.3A.716.716,0,0,0,.628.292.276.276,0,0,0,.749.108c.023-.1.011-.162-.035-.2A.492.492,0,0,0,.421-.151H.368ZM.179.561l-.185.771H-.284L.128-.391H.542a1.317,1.317,0,0,1,.277.022.344.344,0,0,1,.154.074.3.3,0,0,1,.092.161.473.473,0,0,1-.005.217A.608.608,0,0,1,.875.408a.616.616,0,0,1-.346.14l.441.783H.635L.212.561Z"
            transform="translate(0.284 0.391)"
            fill={color}
          />
        </G>
        <G id="g830" transform="translate(9.332 13.056)">
          <Path
            id="path832"
            d="M.371.521H.88L.787.128A.809.809,0,0,1,.774.041C.771.009.768-.027.766-.068.746-.03.727.006.709.038L.653.128Zm.658.676L.929.754H.206L-.112,1.2H-.423L.889-.593,1.342,1.2Z"
            transform="translate(0.423 0.593)"
            fill={color}
          />
        </G>
        <G id="g834" transform="translate(12.063 13.125)">
          <Path
            id="path836"
            d="M.366.111.01,1.6h-.3L.069.111H-.416l.057-.237H.9L.848.111Z"
            transform="translate(0.416 0.126)"
            fill={color}
          />
        </G>
        <G id="g838" transform="translate(15.515 13.124)">
          <Path id="path840" d="M0,.805.412-.917h.3L.3.805Z" transform="translate(0 0.917)" fill={color} />
        </G>
        <G id="g842" transform="translate(17.008 13.057)">
          <Path
            id="path844"
            d="M0,.837.428-.953,1.335.1c.025.03.049.061.073.095s.049.072.075.114L1.768-.886h.274L1.615.9.689-.168A.949.949,0,0,1,.619-.26a.869.869,0,0,1-.06-.1L.272.837Z"
            transform="translate(0 0.953)"
            fill={color}
          />
        </G>
        <G id="g846" transform="translate(19.991 13.125)">
          <Path
            id="path848"
            d="M.365.111.01,1.6h-.3L.069.111H-.416l.057-.237H.9L.848.111Z"
            transform="translate(0.416 0.126)"
            fill={color}
          />
        </G>
        <G id="g850" transform="translate(21.897 13.124)">
          <Path
            id="path852"
            d="M0,.805.412-.917H1.43l-.057.238H.651l-.1.432h.722L1.21,0H.489L.356.555h.722l-.06.25Z"
            transform="translate(0 0.917)"
            fill={color}
          />
        </G>
        <G id="g854" transform="translate(24.025 13.125)">
          <Path
            id="path856"
            d="M.249.343H.3A.716.716,0,0,0,.628.292.276.276,0,0,0,.749.108c.023-.1.011-.162-.035-.2A.492.492,0,0,0,.421-.151H.368ZM.179.561l-.185.771H-.284L.128-.391H.542a1.317,1.317,0,0,1,.277.022.344.344,0,0,1,.154.074.3.3,0,0,1,.092.161.473.473,0,0,1-.005.217A.608.608,0,0,1,.875.408a.616.616,0,0,1-.346.14l.441.783H.635L.212.561Z"
            transform="translate(0.284 0.391)"
            fill={color}
          />
        </G>
        <G id="g858" transform="translate(26.224 13.124)">
          <Path
            id="path860"
            d="M0,.805.412-.917H1.43l-.057.238H.651l-.1.429h.722L1.212,0H.49L.3.805Z"
            transform="translate(0 0.917)"
            fill={color}
          />
        </G>
        <G id="g862" transform="translate(27.995 13.056)">
          <Path
            id="path864"
            d="M.372.521H.88L.787.128C.782.1.778.074.774.041S.767-.027.765-.068C.746-.03.727.006.708.038S.671.1.653.128ZM1.03,1.2.929.754H.206L-.111,1.2H-.423L.888-.593,1.342,1.2Z"
            transform="translate(0.423 0.593)"
            fill={color}
          />
        </G>
        <G id="g866" transform="translate(30.757 13.083)">
          <Path
            id="path868"
            d="M.784.215A.678.678,0,0,0,.554.063.771.771,0,0,0,.273.012.835.835,0,0,0-.258.194a.819.819,0,0,0-.3.469.52.52,0,0,0,.072.46A.492.492,0,0,0-.068,1.3.983.983,0,0,0,.253,1.25a1.312,1.312,0,0,0,.321-.164L.5,1.4a1.184,1.184,0,0,1-.29.121,1.227,1.227,0,0,1-.315.04A.994.994,0,0,1-.478,1.5a.658.658,0,0,1-.267-.191A.631.631,0,0,1-.88,1.018.864.864,0,0,1-.866.661,1.1,1.1,0,0,1-.709.305,1.223,1.223,0,0,1-.432.012,1.287,1.287,0,0,1-.075-.18a1.229,1.229,0,0,1,.4-.065.937.937,0,0,1,.3.044.827.827,0,0,1,.251.133Z"
            transform="translate(0.893 0.245)"
            fill={color}
          />
        </G>
        <G id="g870" transform="translate(33.261 13.124)">
          <Path
            id="path872"
            d="M0,.805.412-.917H1.43l-.057.238H.651l-.1.432H1.27L1.211,0H.49L.356.555h.722l-.06.25Z"
            transform="translate(0 0.917)"
            fill={color}
          />
        </G>
        <G id="g874" transform="translate(36.93 13.124)">
          <Path
            id="path876"
            d="M0,.805.412-.917H1.43l-.057.238H.651l-.1.429H1.27L1.211,0H.49L.3.805Z"
            transform="translate(0 0.917)"
            fill={color}
          />
        </G>
        <G id="g878" transform="translate(39.139 13.086)">
          <Path
            id="path880"
            d="M.779.422A.585.585,0,0,0,.788.174.479.479,0,0,0,.693-.035a.458.458,0,0,0-.18-.139.6.6,0,0,0-.245-.05A.775.775,0,0,0,0-.175a.872.872,0,0,0-.25.14A.877.877,0,0,0-.444.173.786.786,0,0,0-.553.422.582.582,0,0,0-.561.669.469.469,0,0,0-.467.877a.463.463,0,0,0,.182.14.6.6,0,0,0,.245.049.761.761,0,0,0,.265-.049.9.9,0,0,0,.25-.14A.892.892,0,0,0,.67.669.731.731,0,0,0,.779.422m.309,0A1.021,1.021,0,0,1,.932.769a1.246,1.246,0,0,1-.282.292,1.367,1.367,0,0,1-.365.2A1.169,1.169,0,0,1-.1,1.326a.913.913,0,0,1-.359-.069.708.708,0,0,1-.269-.2A.642.642,0,0,1-.873.771.8.8,0,0,1-.862.422,1.03,1.03,0,0,1-.706.074,1.256,1.256,0,0,1-.424-.219,1.316,1.316,0,0,1-.061-.414,1.177,1.177,0,0,1,.33-.481a.913.913,0,0,1,.358.067.709.709,0,0,1,.269.195.67.67,0,0,1,.142.3.787.787,0,0,1-.01.346"
            transform="translate(0.887 0.481)"
            fill={color}
          />
        </G>
        <G id="g882" transform="translate(42.02 13.125)">
          <Path
            id="path884"
            d="M.249.343H.3A.713.713,0,0,0,.628.292.274.274,0,0,0,.749.108c.023-.1.011-.162-.035-.2A.492.492,0,0,0,.421-.151H.367ZM.178.561l-.185.771H-.284L.128-.391H.542a1.317,1.317,0,0,1,.277.022.35.35,0,0,1,.154.074.3.3,0,0,1,.091.161.473.473,0,0,1-.005.217A.612.612,0,0,1,.875.408a.618.618,0,0,1-.347.14l.441.783H.634L.212.561Z"
            transform="translate(0.284 0.391)"
            fill={color}
          />
        </G>
        <G id="g886" transform="translate(45.585 13.051)">
          <Path
            id="path888"
            d="M.873.442c0-.013,0-.05.011-.111S.892.24.9.207a.931.931,0,0,1-.06.117A1.2,1.2,0,0,1,.755.444l-.7.918L-.195.426A.856.856,0,0,1-.219.314C-.225.277-.23.242-.233.207A1.013,1.013,0,0,1-.269.32C-.284.36-.3.4-.323.444l-.4.848H-.994l.86-1.8L.144.584C.148.6.154.63.162.67S.178.759.188.818C.218.769.26.706.315.63.331.61.341.594.349.583L1.135-.5l.011,1.8H.871Z"
            transform="translate(0.994 0.503)"
            fill={color}
          />
        </G>
        <G id="g890" transform="translate(48.832 13.086)">
          <Path
            id="path892"
            d="M.779.422A.6.6,0,0,0,.788.174a.48.48,0,0,0-.1-.209.458.458,0,0,0-.18-.139.6.6,0,0,0-.244-.05A.776.776,0,0,0,0-.175a.872.872,0,0,0-.25.14A.861.861,0,0,0-.443.173a.773.773,0,0,0-.11.249A.582.582,0,0,0-.562.669.463.463,0,0,0-.467.877a.454.454,0,0,0,.182.14.593.593,0,0,0,.245.049.761.761,0,0,0,.264-.049.9.9,0,0,0,.25-.14A.909.909,0,0,0,.67.669.744.744,0,0,0,.779.422m.309,0A1.021,1.021,0,0,1,.931.769a1.233,1.233,0,0,1-.282.292,1.347,1.347,0,0,1-.365.2A1.166,1.166,0,0,1-.1,1.326a.913.913,0,0,1-.359-.069.7.7,0,0,1-.268-.2A.629.629,0,0,1-.873.771.8.8,0,0,1-.862.422,1.043,1.043,0,0,1-.706.074,1.256,1.256,0,0,1-.424-.219,1.32,1.32,0,0,1-.061-.414,1.174,1.174,0,0,1,.33-.481a.908.908,0,0,1,.357.067.712.712,0,0,1,.27.195.676.676,0,0,1,.141.3.777.777,0,0,1-.01.346"
            transform="translate(0.887 0.481)"
            fill={color}
          />
        </G>
        <G id="g894" transform="translate(51.713 13.057)">
          <Path
            id="path896"
            d="M0,.837.428-.953,1.336.1c.024.03.048.061.073.095s.049.072.074.114L1.769-.886h.274L1.615.9.689-.168A.949.949,0,0,1,.619-.26a.973.973,0,0,1-.06-.1L.272.837Z"
            transform="translate(0 0.953)"
            fill={color}
          />
        </G>
        <G id="g898" transform="translate(54.533 13.124)">
          <Path
            id="path900"
            d="M0,.805.412-.917H1.43l-.057.238H.651l-.1.432h.722L1.21,0H.489L.356.555h.722l-.06.25Z"
            transform="translate(0 0.917)"
            fill={color}
          />
        </G>
        <G id="g902" transform="translate(56.852 13.124)">
          <Path
            id="path904"
            d="M.094.805.283.017-.108-.917H.2l.242.584c.005.016.013.035.021.059L.49-.2C.507-.222.526-.248.545-.273S.582-.318.6-.34l.531-.577h.3L.577.017.388.805Z"
            transform="translate(0.108 0.917)"
            fill={color}
          />
        </G>
      </G>
      <G id="layer1-2" data-name="layer1" transform="translate(66.759 0)">
        <G id="g22" transform="translate(0)">
          <G id="Group_3891" data-name="Group 3891">
            <G id="g30" transform="translate(0 12.813)">
              <Path
                id="path32"
                d="M-.71,0h.316L-.688,1.227a.526.526,0,0,0,.025.41.371.371,0,0,0,.335.137.582.582,0,0,0,.4-.137.767.767,0,0,0,.221-.41L.586,0h.32l-.3,1.257a1.086,1.086,0,0,1-.349.613,1.008,1.008,0,0,1-.657.2.658.658,0,0,1-.558-.2.728.728,0,0,1-.053-.614Z"
                transform="translate(1.05)"
                fill={color}
              />
            </G>
            <G id="g34" transform="translate(1.914 12.733)">
              <Path
                id="path36"
                d="M0-4.393l.5-2.1.955,1.235c.026.035.051.072.077.112s.051.084.078.134l.335-1.4h.3l-.5,2.1L.767-5.571a1.125,1.125,0,0,1-.073-.107A1.158,1.158,0,0,1,.631-5.8l-.336,1.4Z"
                transform="translate(0 6.493)"
                fill={color}
              />
            </G>
            <G id="g38" transform="translate(4.132 12.813)">
              <Path id="path40" d="M0-4.225l.484-2.02H.8L.32-4.225Z" transform="translate(0 6.246)" fill={color} />
            </G>
            <G id="g42" transform="translate(4.912 12.813)">
              <Path
                id="path44"
                d="M0-4.225l.484-2.02h1.1l-.067.279H.737l-.121.5H1.4l-.069.288H.547l-.227.95Z"
                transform="translate(0 6.246)"
                fill={color}
              />
            </G>
            <G id="g46" transform="translate(6.364 12.813)">
              <Path id="path48" d="M0-4.225l.484-2.02H.8L.32-4.225Z" transform="translate(0 6.246)" fill={color} />
            </G>
            <G id="g50" transform="translate(7.144 12.813)">
              <Path
                id="path52"
                d="M0-4.225l.484-2.02h1.1l-.067.279H.737l-.121.506h.779l-.069.288H.547L.39-4.519h.779l-.07.294Z"
                transform="translate(0 6.246)"
                fill={color}
              />
            </G>
            <G id="g54" transform="translate(8.61 12.813)">
              <Path
                id="path56"
                d="M-.818-3.6h.269a1.454,1.454,0,0,0,.34-.03.64.64,0,0,0,.218-.1.855.855,0,0,0,.226-.244A1.138,1.138,0,0,0,.372-4.32.914.914,0,0,0,.4-4.658.451.451,0,0,0,.288-4.9.367.367,0,0,0,.112-5a1.487,1.487,0,0,0-.357-.03H-.476Zm-.391.3.484-2.02h.432a2.6,2.6,0,0,1,.582.043.6.6,0,0,1,.266.146A.616.616,0,0,1,.731-4.8,1.172,1.172,0,0,1,.7-4.317a1.472,1.472,0,0,1-.2.477A1.211,1.211,0,0,1,.161-3.5a1.047,1.047,0,0,1-.329.146,2.348,2.348,0,0,1-.524.043h-.518Z"
                transform="translate(1.209 5.328)"
                fill={color}
              />
            </G>
            <G id="g58" transform="translate(11.481 12.813)">
              <Path
                id="path60"
                d="M-1.258-1.766h.082a.806.806,0,0,0,.369-.059.309.309,0,0,0,.139-.21q.039-.161-.04-.228a.563.563,0,0,0-.333-.066h-.082Zm-.085.269-.217.907h-.3l.484-2.02h.484a1.416,1.416,0,0,1,.311.024.368.368,0,0,1,.158.079.342.342,0,0,1,.1.19.612.612,0,0,1-.01.263.814.814,0,0,1-.116.265A.646.646,0,0,1-.64-1.6a.612.612,0,0,1-.2.079,1.625,1.625,0,0,1-.322.023h-.184Z"
                transform="translate(1.86 2.611)"
                fill={color}
              />
            </G>
            <G id="g62" transform="translate(12.529 12.733)">
              <Path
                id="path64"
                d="M-1.826-2.733h.549l-.092-.461c0-.029-.008-.063-.012-.1s-.006-.081-.007-.128q-.032.066-.064.124t-.062.105Zm.7.793-.1-.52h-.78l-.353.52H-2.7l1.456-2.1.45,2.1Z"
                transform="translate(2.699 4.04)"
                fill={color}
              />
            </G>
            <G id="g66" transform="translate(14.714 12.813)">
              <Path
                id="path68"
                d="M-.376-4.225l.221-.925-.4-1.1h.336L.03-5.56c.006.018.013.041.02.069s.016.059.023.092c.02-.032.041-.063.061-.091S.176-5.544.2-5.568l.586-.677H1.1l-.94,1.1-.221.925Z"
                transform="translate(0.555 6.246)"
                fill={color}
              />
            </G>
            <G id="g70" transform="translate(15.913 12.727)">
              <Path
                id="path72"
                d="M-4.255-2.318q0-.023.014-.13.01-.088.016-.146a1.28,1.28,0,0,1-.067.138,1.627,1.627,0,0,1-.089.141l-.773,1.076-.252-1.1a1.284,1.284,0,0,1-.024-.131c-.005-.042-.009-.084-.011-.126-.011.042-.025.087-.042.133s-.037.1-.061.146L-6-1.32H-6.29l.969-2.106.276,1.275c0,.02.01.054.017.1s.015.1.025.174q.049-.087.142-.221l.037-.055.873-1.274L-3.979-1.32h-.3Z"
                transform="translate(6.29 3.426)"
                fill={color}
              />
            </G>
            <G id="g74" transform="translate(18.48 12.813)">
              <Path
                id="path76"
                d="M0-4.225l.484-2.02h1.1l-.067.279H.737l-.121.506h.779l-.069.288H.547L.39-4.519h.779L1.1-4.225Z"
                transform="translate(0 6.246)"
                fill={color}
              />
            </G>
            <G id="g78" transform="translate(19.946 12.733)">
              <Path
                id="path80"
                d="M0-4.393l.5-2.1.955,1.235c.026.035.051.072.077.112s.051.084.078.134l.335-1.4h.3l-.5,2.1L.767-5.571a1.125,1.125,0,0,1-.073-.107A1.158,1.158,0,0,1,.631-5.8l-.336,1.4Z"
                transform="translate(0 6.493)"
                fill={color}
              />
            </G>
            <G id="g82" transform="translate(22.369 12.813)">
              <Path
                id="path84"
                d="M-1.764-.583l-.417,1.742H-2.5l.417-1.742h-.523l.067-.279h1.364l-.067.279Z"
                transform="translate(2.607 0.861)"
                fill={color}
              />
            </G>
            <G id="g86" transform="translate(23.544 12.767)">
              <Path
                id="path88"
                d="M0-3.475.284-3.6a.274.274,0,0,0,.084.206A.335.335,0,0,0,.6-3.319.386.386,0,0,0,.845-3.4a.381.381,0,0,0,.136-.218Q1.024-3.8.769-3.936l-.055-.03a.988.988,0,0,1-.363-.295A.426.426,0,0,1,.32-4.583a.692.692,0,0,1,.259-.4.744.744,0,0,1,.465-.153.6.6,0,0,1,.344.086.329.329,0,0,1,.144.248l-.282.132a.3.3,0,0,0-.1-.139A.249.249,0,0,0,1-4.854a.362.362,0,0,0-.222.069A.317.317,0,0,0,.66-4.6q-.043.182.252.339l.036.019a.843.843,0,0,1,.336.27.433.433,0,0,1,.03.329.792.792,0,0,1-.285.456.815.815,0,0,1-.517.169.556.556,0,0,1-.384-.119A.423.423,0,0,1,0-3.475"
                transform="translate(0 5.136)"
                fill={color}
              />
            </G>
            <G id="g90" transform="translate(25.909 12.813)">
              <Path id="path92" d="M0-4.225l.484-2.02H.8L.32-4.225Z" transform="translate(0 6.246)" fill={color} />
            </G>
            <G id="g94" transform="translate(26.689 12.733)">
              <Path
                id="path96"
                d="M0-4.393l.5-2.1.955,1.235c.026.035.051.072.077.112s.051.084.078.134l.335-1.4h.3l-.5,2.1L.767-5.571a1.126,1.126,0,0,1-.073-.107A1.181,1.181,0,0,1,.631-5.8l-.336,1.4Z"
                transform="translate(0 6.493)"
                fill={color}
              />
            </G>
            <G id="g98" transform="translate(29.112 12.813)">
              <Path
                id="path100"
                d="M-1.764-.583l-.417,1.742H-2.5l.417-1.742h-.523l.067-.279h1.364l-.067.279Z"
                transform="translate(2.607 0.861)"
                fill={color}
              />
            </G>
            <G id="g102" transform="translate(30.304 12.813)">
              <Path
                id="path104"
                d="M0-4.225l.484-2.02h1.1l-.067.279H.737l-.121.506h.779l-.069.288H.547L.39-4.519h.779l-.07.294Z"
                transform="translate(0 6.246)"
                fill={color}
              />
            </G>
            <G id="g106" transform="translate(31.77 12.813)">
              <Path
                id="path108"
                d="M-1.25-1.8h.058A.721.721,0,0,0-.84-1.861.327.327,0,0,0-.7-2.077q.04-.167-.033-.235a.491.491,0,0,0-.315-.068h-.058Zm-.081.255-.216.9h-.3l.484-2.02h.447a1.272,1.272,0,0,1,.3.026.355.355,0,0,1,.164.087.351.351,0,0,1,.1.189.607.607,0,0,1-.011.254.74.74,0,0,1-.205.38.65.65,0,0,1-.377.165l.458.919H-.856l-.439-.9Z"
                transform="translate(1.848 2.662)"
                fill={color}
              />
            </G>
            <G id="g110" transform="translate(33.313 12.813)">
              <Path
                id="path112"
                d="M0-4.225l.484-2.02h1.1l-.067.279H.737l-.121.5H1.4l-.069.288H.547l-.227.95Z"
                transform="translate(0 6.246)"
                fill={color}
              />
            </G>
            <G id="g114" transform="translate(34.393 12.733)">
              <Path
                id="path116"
                d="M-1.826-2.733h.549l-.092-.461q-.007-.044-.012-.1c0-.038-.006-.081-.007-.128q-.032.066-.064.124t-.062.105Zm.7.793-.1-.52h-.78l-.353.52H-2.7l1.456-2.1.45,2.1Z"
                transform="translate(2.699 4.04)"
                fill={color}
              />
            </G>
            <G id="g118" transform="translate(36.557 12.765)">
              <Path
                id="path120"
                d="M-3.818-1.129a.706.706,0,0,0-.245-.178.76.76,0,0,0-.3-.059.872.872,0,0,0-.576.212A1,1,0,0,0-5.277-.6a.65.65,0,0,0,.068.539.5.5,0,0,0,.446.213A1,1,0,0,0-4.415.086a1.428,1.428,0,0,0,.349-.192l-.089.371A1.23,1.23,0,0,1-4.47.407,1.228,1.228,0,0,1-4.81.454a.987.987,0,0,1-.4-.076A.69.69,0,0,1-5.493.155a.743.743,0,0,1-.139-.342A1.082,1.082,0,0,1-5.61-.606a1.368,1.368,0,0,1,.177-.417,1.418,1.418,0,0,1,.306-.343,1.36,1.36,0,0,1,.39-.226,1.235,1.235,0,0,1,.429-.077.939.939,0,0,1,.318.052.845.845,0,0,1,.268.157Z"
                transform="translate(5.644 1.668)"
                fill={color}
              />
            </G>
            <G id="g122" transform="translate(38.414 12.813)">
              <Path
                id="path124"
                d="M0-4.225l.484-2.02h1.1l-.067.279H.737l-.121.506h.779l-.069.288H.547L.39-4.519h.779l-.07.294Z"
                transform="translate(0 6.246)"
                fill={color}
              />
            </G>
            <G id="g126" transform="translate(30.375)">
              <Path
                id="path128"
                d="M-4.6-23.116H-6.8l3.06-11.053h2.2Z"
                transform="translate(6.803 34.169)"
                fill={color}
              />
            </G>
            <G id="g130" transform="translate(15.56 0.033)">
              <Path
                id="path132"
                d="M-33.2-.662A.816.816,0,0,0-33.9-.978h-12.1l-.6,2.165H-35.6L-36.237,3.5h-8.806v0h-2.2l-1.827,6.594h2.2l1.226-4.426h9.9a1.406,1.406,0,0,0,.874-.316,1.468,1.468,0,0,0,.539-.782L-33.105.137a.9.9,0,0,0-.092-.8"
                transform="translate(49.07 0.978)"
                fill={color}
              />
            </G>
            <G id="g134" transform="translate(1.116 0.032)">
              <Path
                id="path136"
                d="M-27.529-21.605a1.011,1.011,0,0,1-.974.74H-39.856a.793.793,0,0,1-.691-.316.879.879,0,0,1-.1-.782l2.77-9.972h2.2l-2.474,8.907h8.81l2.474-8.907h2.2Z"
                transform="translate(40.691 31.936)"
                fill={color}
              />
            </G>
            <G id="g138" transform="translate(36.366 0.021)">
              <Path id="path140" d="M-6.422,0l2.786,5.541L-9.493,11.08Z" transform="translate(9.493)" fill="#27803b" />
            </G>
            <G id="g142" transform="translate(34.408 0.021)">
              <Path id="path144" d="M-6.431,0l2.784,5.541L-9.506,11.08Z" transform="translate(9.506)" fill="#e9661c" />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  )
}
